import { createStore, createHook, createActionsHook, createStateHook } from 'react-sweet-state';
import type { StoreActionApi } from 'react-sweet-state';

import type { ExtractPresetAPI } from '@atlaskit/editor-common/preset';
import type { fullPagePreset } from '@atlassian/confluence-presets/full-page';

export type FullPageEditorPresetAPI = ExtractPresetAPI<ReturnType<typeof fullPagePreset>>;

export type FullPageEditorStoreState = {
	fullPageEditorPresetAPI?: FullPageEditorPresetAPI;
};

export const initialState: FullPageEditorStoreState = {
	fullPageEditorPresetAPI: undefined,
};

export const actions = {
	setEditorApi:
		(fullPageEditorPresetAPI?: FullPageEditorPresetAPI) =>
		({ setState }: StoreActionApi<FullPageEditorStoreState>) => {
			setState({
				fullPageEditorPresetAPI,
			});
		},
	resetEditorApi:
		() =>
		({ setState }: StoreActionApi<FullPageEditorStoreState>) => {
			setState(initialState);
		},
};

const FullPageEditorApiStore = createStore({
	initialState,
	actions,
	name: 'FullPageEditorApiStore',
});

export const useFullPageEditorApi = createHook(FullPageEditorApiStore);
export const useFullPageEditorApiActions = createActionsHook(FullPageEditorApiStore);
export const useFullPageEditorApiState = createStateHook(FullPageEditorApiStore);
